module.exports = __webpack_public_path__ + "img/Julie_Clifford.e9919c7e.png";